import {useQuery} from 'react-query';
import getLoanValidationPrice from './getLoanValidationPrice';

const useGetLoanValidationPrice = () => {
  const {data, isLoading} = useQuery(
    ['loan-validation-price'],
    getLoanValidationPrice,
  );

  return {data, isLoading};
};

export default useGetLoanValidationPrice;
